import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/wholesale-recepts', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/wholesale-recepts', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getInvoice = (Options = {}) => {
  return httpClient
    .get('/api/v1/wholesale-recepts/invoices', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const reprint = id => {
  return httpClient
    .get(`/api/v1/wholesale-recepts/${id}/prints`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const bankProfile = () => {
	return httpClient
	.get('/api/v1/wholesale-recepts/bank-profiles')
	.then(response => Promise.resolve(response.data))
	.catch(error => Promise.reject(error.response.data)) 
}

export const destroy = (id, data) => {
  return httpClient
    .post(`/api/v1/wholesale-recepts/${id}/delete`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  getInvoice,
  reprint,
	bankProfile,
  destroy
}
